export default "__VITE_ASSET__7750a2ea__"